import types from './mutations-types';

const mutations = {
  [types.SET_LIST_ACTIONS](state, payload) {
    state.listActions = [];
    payload.actions.map((element) => {
      state.listActions.push({ ...element.action, id: element._id });
      return true;
    });
    state.totalActions = payload.totalPages;
  },
  [types.SET_LIST_ANSWERS](state, payload) {
    state.listAnswers = [];
    payload.answers.map((element) => {
      state.listAnswers.push({ ...element.answer, id: element._id });
      return true;
    });
    state.totalAnswers = payload.totalPages;
  },
  [types.SET_ACTION](state, payload) {
    state.infoAction = payload.action;
  },
  [types.SET_ANSWER](state, payload) {
    state.infoAnswer = payload.answer;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/trash/mutations.js